import { Component, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { ToastService } from '@app/core/services/toast.service';
import { UserAuthService } from '../../services/userAuth.service';
import { LoadSpinnerWrapperComponent } from '@app/shared/components/load-spinner-wrapper/load-spinner-wrapper.component';
import { Subject, takeUntil } from 'rxjs';
import { PasswordResetStateService } from '../../services/password-reset-state.service';
import { Response } from '@app/core/interfaces/response';

@Component({
  selector: 'app-expired-password',
  imports: [MatButtonModule, RouterModule, LoadSpinnerWrapperComponent],
  templateUrl: './expired-password.component.html',
  styleUrl: './expired-password.component.scss'
})
export class ExpiredPasswordComponent implements OnDestroy {
  loading: boolean = false;
  identifier: string = '';
  ngDestroy$ = new Subject<boolean>();

  constructor(
    private toastService: ToastService,
    private router: Router,
    private userAuthService: UserAuthService,
    private passwordResetState: PasswordResetStateService
  ) {
    this.router.routerState.root.queryParams
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe(params => {
        this.identifier = params['identifier'] || '';
      });
  }

  ngOnDestroy(): void {
    this.ngDestroy$.next(true);
    this.ngDestroy$.complete();
  }

  onResetPassword() {
    if (!this.identifier) {
      this.toastService.showErrorToast('User name not found. Unable to reset password.');
      return;
    }

    this.loading = true;

    this.userAuthService.forgotPassword(this.identifier)
      .subscribe({
        next: (response: Response) => {
          this.loading = false;
          if (!response.succeeded) {
            this.toastService.showErrorToast('Unable to send a password reset code. Please try again.');
            return;
          }

          this.passwordResetState.save(this.identifier);
          this.router.navigate(['/reset-password'], { state: { identifier: this.identifier }});
        },
        error: () => {
          this.loading = false;
          this.toastService.showErrorToast('Unable to send a password reset code. Please try again.');
        }
      });
  }
}
